import { inject, Injectable } from '@angular/core';
import { QualityControlViewTableApiService } from '../../../../views/quality-control/api/table.service';
import { Observable } from 'rxjs';
import { User } from '../../../../api/elite/types/users';
import { InspectionApiDto } from '../../../../api/elite/dto/inspection.dto';
import { Inspection } from '../../../../api/elite/types/inspections';

@Injectable()
export class FiltersQcViewTableApiService extends QualityControlViewTableApiService {
  override getOpenInspection(
    itemIdForInspection: number,
    query: InspectionApiDto['open']['query'] = {}
  ): Observable<Inspection | undefined> {
    return this.apiInspectionService.checkForOpenInspection(
      itemIdForInspection,
      { ...query, fromStage: 'Quality Control' }
    );
  }

  override getInspectors(departmentName: string): Observable<User[]> {
    return this.apiUserRouter.allUsersV2(departmentName, 'inspector');
  }
}
